import { useContext } from "react";
import UserContext from "../context/user-context";
import { ISearchUser } from "../store/types/userTypes";
import { useStore } from "./useStore";

const useValidation = () => {
  const { state } = useContext(UserContext);
  const { tabStore } = useStore();
  const isLoadUser = async (search: ISearchUser) => {
    let flag = false;
    if (
      (state.dni === search.dni && state.countryCode === search.countryCode) ||
      state.id === search.qr ||
      state.id === search.passUserId
    ) {
      flag = true;
    }
    return flag;
  };
  const isLoadUserTab = async (search: ISearchUser) => {
    let flag = false;
    let tabIndex: string = "-1";
    tabStore.tabs.every((tab) => {
      if (tab.isMultipleExit && tab.states) {
        flag = tab.states.some(
          (state) =>
            (state.dni === search.dni &&
              state.countryCode === search.countryCode) ||
            state.id === search.qr
        );
      } else if (tab.state) {
        flag =
          (tab.state.dni === search.dni &&
            tab.state.countryCode === search.countryCode) ||
          tab.state.id === search.qr ||
          tab.state.id === search.passUserId;
      }
      if (flag) {
        tabIndex = tab.index.toString();
        return false;
      } else {
        return true;
      }
    });
    return { isLoad: flag, tabIndex };
  };

  return { isLoadUser, isLoadUserTab };
};

export default useValidation;
